import React from "react"

export default function OurProduct({ data }) {
  const {
    nos_produit_content,
    nos_produit_heading,
  } = data?.allPrismicMainPage.edges[0].node.data

  return (
    <section id="our-product">
      <h1>{nos_produit_heading.text}</h1>
      <div
        className="text-warper"
        dangerouslySetInnerHTML={{ __html: nos_produit_content.html }}
      ></div>
    </section>
  )
}
